import React from 'react';
import {
  REGISTER_ADDRESS_TYPE,
  TRADING_ADDRESS_TYPE,
  DIFFERENT_ADDRESS_TYPE,
  MAILING_ADDRESS_TYPE
} from '../../../../utils/constants';
import ShowAddress from './ShowAddress';
import RegisterAddSelector from './RegisterAddSelector';
import AddressComponent from '../../../../components/Address';
import { getChoosenAddress } from './getChoosenAddress';
import { getSelectedAddress } from '../../../../components/Address/addressUtils/addressUtils';
import MultipleAddressTrading from './MultipleAddressTrading';
import MultipleAddressMailing from './MultipleAddressMailing';

export const renderRegisterAddress = (
  registerAddress,
  isEditClick,
  address,
  onAddressSelection,
  values,
  onEditClick,
  saveFormValues
) => {
  return (
    <div>
      {getShowAddress(
        registerAddress,
        isEditClick,
        onEditClick,
        REGISTER_ADDRESS_TYPE,
        'choosenRegisteredAddress',
        values
      )}
      {(!isEditClick || !registerAddress) && (
        <div>
          <RegisterAddSelector
            type={REGISTER_ADDRESS_TYPE}
            address={address}
            onAddressSelection={onAddressSelection}
            selectedId={values.registerAddressSelector}
          />
          {values.registerAddressSelector === 'No' && (
            <AddressComponent
              type={REGISTER_ADDRESS_TYPE}
              formValues={values}
              saveFormValues={saveFormValues}
              chooseAddress={saveFormValues}
            />
          )}
          {values.registerAddressSelector === 'Yes' &&
            address &&
            getChoosenAddress(
              values.registerAddressSelector,
              address,
              'choosenRegisteredAddress',
              REGISTER_ADDRESS_TYPE
            )}
        </div>
      )}
    </div>
  );
};

export const renderTradingAddress = (
  tradingAddress,
  isEditClick,
  address,
  onAddressSelection,
  values,
  isSoleBusinessType,
  onEditClick,
  getExistingAddres,
  saveFormValues
) => {
  return (
    <div>
      {getShowAddress(
        tradingAddress,
        isEditClick,
        onEditClick,
        TRADING_ADDRESS_TYPE,
        'choosenTradingAddress',
        values
      )}
      {(!isEditClick || !tradingAddress) && (
        <div>
          <MultipleAddressTrading
            isSoleTrader={isSoleBusinessType}
            onAddressSelection={onAddressSelection}
            selectedAddressId={values.mutipleAddressTrading}
          />
          {values.mutipleAddressTrading === DIFFERENT_ADDRESS_TYPE && (
            <AddressComponent
              type={TRADING_ADDRESS_TYPE}
              formValues={values}
              saveFormValues={saveFormValues}
              chooseAddress={saveFormValues}
            />
          )}
          {getChoosenAddress(
            values.mutipleAddressTrading,
            getAddressValue(
              getExistingAddres,
              values,
              values.mutipleAddressTrading,
              address,
              tradingAddress
            ),
            'choosenTradingAddress',
            TRADING_ADDRESS_TYPE
          )}
        </div>
      )}
    </div>
  );
};

export const renderMailingAddress = (
  mailingAddress,
  isEditClick,
  address,
  onAddressSelection,
  values,
  isSoleBusinessType,
  onEditClick,
  getExistingAddres,
  saveFormValues
) => {
  return (
    <div>
      {getShowAddress(
        mailingAddress,
        isEditClick,
        onEditClick,
        MAILING_ADDRESS_TYPE,
        'choosenMailingAddress',
        values
      )}
      {(!isEditClick || !mailingAddress) && (
        <div>
          <MultipleAddressMailing
            isSoleTrader={isSoleBusinessType}
            onAddressSelection={onAddressSelection}
            selectedAddressId={values.mutipleAddressMailing}
          />
          {values.mutipleAddressMailing === DIFFERENT_ADDRESS_TYPE && (
            <AddressComponent
              type={MAILING_ADDRESS_TYPE}
              formValues={values}
              saveFormValues={saveFormValues}
            />
          )}
          {getChoosenAddress(
            values.mutipleAddressMailing,
            getAddressValue(
              getExistingAddres,
              values,
              getAddressValueTrading(values, values.mutipleAddressMailing),
              address,
              mailingAddress
            ),
            'choosenMailingAddress',
            MAILING_ADDRESS_TYPE
          )}
        </div>
      )}
    </div>
  );
};

const getShowAddress = (givenAddress, isEditClick, onEditClick, type, label, values) => {
  const condition = givenAddress && isEditClick;
  if (condition) {
    values[`${type}chosenAddressField`] = givenAddress;
  }
  return (
    condition && (
      <ShowAddress
        type={type}
        label={label}
        value={givenAddress}
        onEditClick={() => {
          onEditClick(type);
        }}
      />
    )
  );
};

const getAddressValue = (getExistingAddres, values, multipleAddressType, address, dataAddress) => {
  return (
    getExistingAddres(multipleAddressType) ||
    getSelectedAddress(values, multipleAddressType, address, dataAddress)
  );
};

const getAddressValueTrading = (values, multipleAddressType) =>
  multipleAddressType === TRADING_ADDRESS_TYPE &&
  values.mutipleAddressTrading &&
  values.mutipleAddressTrading !== DIFFERENT_ADDRESS_TYPE
    ? values.mutipleAddressTrading
    : multipleAddressType;
